<template>
  <div>
    <div class="d-flex justify-center">
      <div class="community">
        <div class="community__title mb-5">Communities</div>

        <div class="community__subtitle my-3">Your profile</div>
        <div class="community__item" @click="$router.push('/username/m')">
          <img
            class="community__item--image"
            src="../../assets/mobile/community.png"
          />
          <div class="community__item__content d-flex justify-space-between">
            <span class="text-left">You</span>
            <span class="text-right">Platinum • 1m</span>
          </div>
        </div>

        <div class="community__subtitle mb-3 mt-4">Subscribed</div>
        <div class="community__item mb-2" @click="$router.push('/username/m')">
          <img
            class="community__item--image"
            src="../../assets/mobile/community.png"
          />
          <div class="community__item__content d-flex justify-space-between">
            <span class="text-left">SALVA</span>
            <span class="text-right">Platinum • 1m</span>
          </div>
        </div>
        <div class="community__item" @click="$router.push('/username/m')">
          <img
            class="community__item--image"
            src="../../assets/mobile/community.png"
          />
          <div class="community__item__content d-flex justify-space-between">
            <span class="text-left">Tri Nohbi</span>
            <span class="text-right">Acapella packs • 1w</span>
          </div>
        </div>

        <div class="community__subtitle mt-4 mb-3">Following</div>
        <div
          class="community__item mb-5 pb-5"
          @click="$router.push('/username/m')"
        >
          <img
            class="community__item--image"
            src="../../assets/mobile/community.png"
          />
          <div class="community__item__content d-flex justify-space-between">
            <span class="text-left">You</span>
            <span class="text-right">Platinum • 1m</span>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "./components/footer";

export default {
  components: {
    Footer,
  },
};
</script>

<style lang="scss" scoped>
.community {
  max-width: 344px;
  &__title {
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 70%; /* 16.8px */
    letter-spacing: -0.48px;
  }

  &__subtitle {
    color: rgba(0, 0, 0, 0.6);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 80%; /* 14.4px */
    letter-spacing: -0.36px;
  }

  &__item {
    position: relative;
    width: 344px;
    height: 132px;
    &--image {
      position: absolute;
      width: 344px;
      height: 132px;
    }
    &__content {
      position: absolute;
      bottom: 15px;
      left: 15px;
      right: 15px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      line-height: 150%;
      letter-spacing: -0.14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// community.vue?182da635